var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['message-abstract-image']},[_c('img',{class:['messageImage'],attrs:{"src":_vm.messageContent.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }